export default "__VITE_PUBLIC_ASSET__a9ed17d3__"